export const JoinNetworkMixin = {
  methods: {
    joinNetwork(network) {
      if (!this.$store.getters.auth) {
        this.$bus.emit(
          'show-sign-in',
          '/join-network?network=' + network.slug,
          this.$t('JoinNetworkMixin.to-access-this-network-login-or-start-your-journey-with-us-today')
        );
        return;
      }
      // ask the user for confirmation first
      this.$swal.fire({
        title: this.$t('network.confirmMembership'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('ResearchCreds.yes'),
        cancelButtonText: this.$t('cancel'),
        customClass: {
          confirmButton: 'btn btn-primary mx-1',
          cancelButton: 'btn btn-secondary mx-1'
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push('/join-network?network=' + network.slug);
        }
      });
    },
  },
};
